import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@nab/shared/styles.css";
// Must precede App: initI18n sets the document's lang and dir before the first render, so the
// layout does not flash left-to-right before mirroring for an Arabic user.
import "./i18n";
import "./styles.css";

import { App } from "./App";
import { RouterProvider, Styleguide } from "@nab/shared";

const container = document.getElementById("root");
if (!container) {
  throw new Error("root element is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    {/* The styleguide stays outside the router and outside the session: it renders primitives with
        sample data, needs no navigation of its own, and a styleguide behind a login is a styleguide
        nobody opens. Everything else is routed. */}
    {window.location.pathname === "/styleguide" ? (
      <Styleguide />
    ) : (
      <RouterProvider>
        <App />
      </RouterProvider>
    )}
  </StrictMode>,
);
